import {
  Validator
} from 'vee-validate';
import {
  BasicSelect
} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import BookingService from './../../../../services/cargobooking.service';
import ClientService from './../../../../../clientmanagement/services/clientmanagement.service';
import Util from './../../../../../shared/util/util';
import moment from 'moment';
import Multiselect from 'vue-multiselect'

export default {
  name: 'basicinformation',
  components: {
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    Pagination,
    Treeselect,
    Multiselect,
    VueElementLoading

  },
  props: ['bookingData', 'status'],
  data() {
    return {
      accordianTab: {
        1: false,
        2: false,
        3: false
      },
      expanded: false,
      isBasicInfoLoading: false,
      ClientUOM: '',
      BookingMode: 'Credit',
      PickupPincode: '',
      RouteMode: 'Surface',
      TruckLoadType: 'PTL',
      DestinationHub: '',
      DestinationHubId: '',
      DestinationPincode: '',
      OriginHub: '',
      OriginHubId: '',
      State: '',
      ConsigneeState: '',
      City: '',
      ConsigneeCity: '',
      pincode: '',
      breadth: '',
      height: '',
      length: '',
      box: '',
      Mobile: '',
      Telephone: '',
      Email: '',
      GstNo: '',
      ShipmentDropByClient: false,
      PinCode: '',
      Address: '',
      SKU: '',
      SKUData: [],
      SKUlist: [],
      Location: null,
      LocationName: "",
      AddNewLocationFlag: false,
      NumberOfMPS: '',
      boxes: '',
      TotalShipmentValue: '',
      TotalShipmentWeight: '',
      RequestedPickupDate: Util.getCurrentDateOnly(),
      RequestedPickupTimeFrom: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }),
      RequestedPickupTimeTo: '23:59',
      NumberOfInvoice: '',
      Locationlist: [],
      shipmentData: [],
      shipmentdetails: {
        skulist: [],
        hsn: [],
        boxtype: [],
        boxdimension: [],
        averagephysicalweight: [],
        averagevolumetricweight: [],
        noofboxes: [],
        uom: []
      },
      form: {
        skulist: [],
        otherskuname: [],
        skulistError: [],
        hsn: [],
        boxtype: [],
        boxlist: [],
        boxtypeError: [],
        boxdimension: [],
        averagephysicalweight: [],
        averagevolumetricweight: [],
        noofboxes: [],
        noofboxesError: [],
        otherboxname: [],
        boxtypeforother: []
      },
      boxlist: [],
      LocatioItem: {
        value: '',
        text: ''
      },
      SKUItem: {
        value: '',
        text: ''
      },
      boxItem: {
        value: '',
        text: ''
      },
      userName: "",
      PickupPincodeServicable: 2,
      DestinationPincodeServicable: 2,
      pincodeservicabilitycheckflag: false,
      basicInformationData: [],
      todaysDate: '',
      editServicabilityflag: false,
      editBasicDetailsflag: false,
      editPickupLocation:true,
      editShipmentValue:true,
      editShipmentDimensions:true,
      subtabdisabledflag: true,
      clientid: '',
      actualwtconfigparam: {},
      manifestMethods: [],
      cm: null,
      inches: null,
      convertermodal: false,
      defaultHubID: '',
      userRoleFlag: '',
      sourcepincodeerrmsg: '',
      destinationpincodeerrmsg: '',
      clientbusinessaccid: '',
      MaxVolumetricWeight:'',
      MaxTotalVolumetricWeight: '',
      clientboxtypelist: [],
      clientproductlist:[],
      selectedboxtype: [],
      selectedproduct: [],
      clientboxtypelistall: [],
      clientproductlistall: [],
      boxTypeshow: false,
      otherproduct: [],
      otherbox: [],
      isProductSelected:[],
      editDimensionflag:[],
	  checked: null,
	  checkflag:false,
	  awbNo:'',
	  awbSeries:[],
    airCargoOptions : '',
    businesstype : null,
    airlinename : null,
    flighttype : null,
    producttype : null,
    isCargoAirShipment:false,
    disableShipmentDropByClient:false,
    businesstypedisabled : false,
    airCargobillData: [],
    cbid : "",
    editGSTNo:false,
    ratetemplate : null,
    paymentpending: false,
    MaxTotalPhysicalWeight : "",
    MaxAveragePhysicalWeight : ""
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.defaultHubID = userdetail.hubID[0];
    this.userRoleFlag = (userdetail.rolename[0] == "Hub Executive" || userdetail.rolename[0] == "Hub Incharge" || userdetail.rolename[0] == "Hub Manager" || userdetail.rolename[0] == "TSP BA Admin") ? 1 : 2;
    this.todaysDate = Util.getCurrentDateOnly();
    this.accordianTab[1] = true;
    await this.getAirCargoData();

    if (this.bookingData.id) {
      this.clientid = this.bookingData.clientid;
      this.clientbusinessaccid = this.bookingData.clientbusinessaccountid;
      this.ActiveContract = this.bookingData.activecontract;
      this.subtabdisabledflag = false;
      this.accordianTab[1] = false;
      if (this.bookingData.status > 0) {
        this.editServicabilityflag = true;
        this.editBasicDetailsflag = true;
        if(this.bookingData.pickuplocationname == null || this.bookingData.pickupgst == null || this.bookingData.pickupmobile == null || this.bookingData.pickupemail == null){
          this.editPickupLocation = false;
          this.accordianTab[2] = true;
          this.editGSTNo=true
        } else if(this.bookingData.bookingmethod == "App" && this.bookingData.totalshipmentvalues == null){
          this.editShipmentValue = false;
          this.accordianTab[3] = true;
        }else if(this.bookingData.bookingmethod == "Upload" && this.bookingData.totalvolumetricweight == null){
          this.editShipmentDimensions = false;
          this.accordianTab[3] = true;
        }
      }
      if (this.bookingData.businesstype) {
        this.businesstype = this.airCargoOptions.resultbusinesstype.filter(item => {return item.id ==  this.bookingData.businesstype})[0];
        this.airlinename = this.airCargoOptions.resultairlinename.filter(item => {return item.id ==  this.bookingData.airlinename})[0];
        this.producttype = this.airCargoOptions.resultproducttype.filter(item => {return item.id ==  this.bookingData.producttype})[0];
        this.flighttype = this.airCargoOptions.resultflighttype.filter(item => {return item.id ==  this.bookingData.flighttype})[0];
        if (!this.bookingData.transactionid && this.editBasicDetailsflag) {
          this.editBasicDetailsflag = false
          this.paymentpending = true
        }
      }
      // if(this.bookingData.status>1){
      //   this.editBasicDetailsflag = true;
      // }
      await Promise.all([
        this.getPickupLocationList(this.bookingData.clientid, this.bookingData.pickuppincode, this.bookingData.clientbusinessaccountid),
        this.getSKUList(this.bookingData.clientid, this.bookingData.clientbusinessaccountid),
        this.getClientUOM(this.bookingData.clientid, this.bookingData.clientbusinessaccountid),
        this.getClientBoxTypeList(this.bookingData.clientid, this.bookingData.clientbusinessaccountid),
        this.getMaxVolumetricWeight()
      ]);
      this.pincodeservicabilitycheckflag = true;
      this.PickupPincodeServicable = 1;
      this.DestinationPincodeServicable = 1;
      this.basicInformationData = this.bookingData;
      this.setValues();
    } else {
      let shipmentDataArr = [];
      shipmentDataArr.push({
        skulist: '',
        hsn: '',
        boxtype: '',
        boxdimension: '',
        averagephysicalweight: '',
        averagevolumetricweight: '',
        noofboxes: '',
      });
      this.shipmentData = shipmentDataArr;
      this.form.skulist[0] = null;
      this.form.skulistError[0] = '';
      this.form.hsn[0] = '';
      this.form.boxtype[0] = null;
      this.form.otherskuname[0] = "";
      this.form.otherboxname[0] = "";
      this.form.boxlist[0] = [];
      this.form.boxtypeError[0] = '';
      this.form.boxdimension[0] = {
        length: '',
        breadth: '',
        height: ''
      };
      this.form.averagephysicalweight[0] = '';
      this.form.averagevolumetricweight[0] = '';
      this.form.noofboxes[0] = '';
      this.form.noofboxesError[0] = '';
    }
  },
  methods: {
    async checkhover(){
      const btn = document.getElementById('btn'),
      tooltip = document.getElementById('tooltip');
      if (tooltip.style.display === "none") {
        tooltip.style.display = "block";
        setTimeout(()=> {
          tooltip.style.display  = "none";
        }, 2000);
    }
    else{
      tooltip.style.display  = "none";
    }
    },
    handleTab(tabid) {
      for (var key in this.accordianTab) {
        if (tabid = key) {
          this.accordianTab[key] = false;
        }
        if (tabid == 1) {
          this.accordianTab[1] = true;
        }
      }
    },
    handleTab1(tabid) {
      for (var key in this.accordianTab) {
        if (tabid = key) {
          this.accordianTab[key] = false;
        }
        if (tabid = 2) {
          this.accordianTab[3] = true;
        }
      }
    },
    handleTab2(tabid) {
      for (var key in this.accordianTab) {
        if (tabid = key) {
          this.accordianTab[key] = false;
        }
      }
    },
    processTags(evt){

    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    ChkDropByClient() {
      if (!this.ShipmentDropByClient && this.Locationlist.length == 1) {
        this.Location = this.Locationlist[0];
        this.Mobile = this.Location.mobile;
        this.Telephone = this.Location.telephone;
        this.Email = this.Location.email;
        this.Address = this.Location.address;
        this.GstNo = this.Location.gstno;
        this.AddNewLocationFlag = false;
        this.editGSTNo = false;
      } else if (!this.ShipmentDropByClient && this.Locationlist.length != 1) {
        this.Location = null;
        this.Mobile = "";
        this.Telephone = "";
        this.Email = "";
        this.Address = "";
        this.GstNo = "";
        this.AddNewLocationFlag = false;
        this.editGSTNo = false;
      }else{
        this.Mobile = "";
        this.Telephone = "";
        this.Email = "";
        this.GstNo = "";
      }
      this.LocationName = "";
    },
    selectedLocation() {
      if (this.Location) {
        this.Mobile = this.Location.mobile;
        this.Telephone = this.Location.telephone;
        this.Email = this.Location.email;
        this.Address = this.Location.address;
        this.GstNo = this.Location.gstno
      } else {
        this.Mobile = "";
        this.Telephone = "";
        this.Email = "";
        this.Address = "";
        this.GstNo = "";
      }
    },
    addNewLocation() {
      this.LocationName = this.bookingData.pickuplocationname;
      this.Mobile = this.bookingData.pickupmobile;
      this.Telephone = this.bookingData.pickuptelephone;
      this.Email = this.bookingData.pickupemail;
      this.Address = this.bookingData.pickupaddress;
      this.GstNo = this.bookingData.pickupgst;
      this.AddNewLocationFlag = true;
    },
    setname(id, name) {
      return name + id;
    },
    selectedSKU(id) {
      if (this.form.skulist[id] != null) {
        let skudata = this.SKUlist;
        let skuval = this.form.skulist[id];
        for (var i = 0; i < skudata.length; i++) {
          if (skudata[i].label == skuval) {
            this.form.hsn[id] = skudata[i].hsn;
          }
        }
        this.form.otherskuname[id] = "";
        this.form.otherboxname[id] = "";
        this.form.skulistError[id] = "";
        this.form.boxtype[id] = null;
        this.form.boxdimension[id] = {};
        this.form.averagephysicalweight[id] = "";
        this.form.averagevolumetricweight[id] = "";
        //this.getBoxTypeList(id);
      } else {
        this.form.skulistError[id] = "Please select SKU";
        this.form.boxlist[id] = [];
        this.form.boxtype[id] = null;
      }
    },
    async ClearCheckServicabilityFlag() {
      this.pincodeservicabilitycheckflag = false;
      this.PickupPincodeServicable = 2;
      this.DestinationPincodeServicable = 2;
      this.airlinename  = null;
      this.producttype  = null;
      this.flighttype  = null;

	  if(this.BookingMode == 'To Pay'){
		await this.$fire({
			text: "FTC booking mode is selected, Do you want to continue with FTC selection?",
			type: 'question',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		  }).then((result) => {
			if(result.value == true) {
			  this.BookingMode = 'To Pay'
			}else{
				this.BookingMode = 'Credit'
			}
		  }).catch((err)=>{
		   console.log(err)
		  })
	  }
      this.subtabdisabledflag = true;
      this.expanded = false;
      this.accordianTab[2] = false;
      this.accordianTab[3] = false;
    },
    clearPickupServicableflag() {
      this.pincodeservicabilitycheckflag = false;
      this.PickupPincodeServicable = 2;
      this.OriginHub = '';
      this.OriginHubId = '';
      this.PinCode = '';
      this.City = '';
      this.State = '';
      this.Location = null;
      this.Locationlist = [];
      this.subtabdisabledflag = true;
      this.expanded = false;
      this.accordianTab[2] = false;
      this.accordianTab[3] = false;
    },
    clearDestinationServicableflag() {
      this.pincodeservicabilitycheckflag = false;
      this.DestinationPincodeServicable = 2;
      this.DestinationHub = '';
      this.DestinationHubId = '';
      this.ConsigneeCity = '';
      this.ConsigneeState = '';
      this.subtabdisabledflag = true;
      this.expanded = false;
      this.accordianTab[2] = false;
      this.accordianTab[3] = false;
    },
    resetPincode() {
      this.PickupPincode = "";
      this.DestinationPincode = "";
      this.PickupPincodeServicable = 2;
      this.DestinationPincodeServicable = 2;
      this.OriginHub = '';
      this.OriginHubId = '';
      this.DestinationHub = '';
      this.DestinationHubId = '';
      this.PinCode = '';
      this.City = '';
      this.State = '';
      this.Location = null;
      this.Locationlist = [];
      this.subtabdisabledflag = true;
      this.expanded = false;
      this.accordianTab[2] = false;
      this.accordianTab[3] = false;
      this.actualwtconfigparam = {};
      this.sourcepincodeerrmsg = '';
      this.destinationpincodeerrmsg = '';
      this.airlinename  = null;
      this.producttype  = null;
      this.flighttype  = null;
    },
    addNewRow(index) {
      let noofboxCount = 0;
      let reqBox = 0;
      for (var i = 0; i < this.form.noofboxes.length; i++) {
        reqBox += parseInt(this.form.noofboxes[i]);
      }
      if (this.NumberOfMPS == "") {
        this.$alert("Please enter Number of MPS", "", "error");
        return false;
      } else {
        if (reqBox > parseInt(this.NumberOfMPS)) {
          this.$alert("Number of MPS & Total Number of boxes not matched", "", "error");
          return false;
        } else if (reqBox == parseInt(this.NumberOfMPS)) {
          this.$alert("Number of MPS & Total Number of boxes are matched. You can not add more.", "", "error");
          return false;
        } else {
          this.shipmentData.push({
            skulist: '',
            hsn: '',
            boxtype: '',
            boxdimension: '',
            averagephysicalweight: '',
            averagevolumetricweight: '',
            noofboxes: '',
          });
          this.form.skulist[index + 1] = null;
          this.form.otherskuname[index + 1] = "";
          this.form.skulistError[index + 1] = "";
          this.form.hsn[index + 1] = '';
          this.form.boxtype[index + 1] = null;
          this.form.otherboxname[index + 1] = "";
          this.form.boxtypeError[index + 1] = "";
          this.form.boxdimension[index + 1] = {
            length: '',
            breadth: '',
            height: ''
          };
          this.form.averagephysicalweight[index + 1] = '';
          this.form.averagevolumetricweight[index + 1] = '';
          this.form.noofboxes[index + 1] = '';
          this.form.noofboxesError[index + 1] = '';
          this.clientboxtypelist[index + 1] = this.clientboxtypelistall;
        }
      }
    },
    deleteRow(index) {
      this.$confirm("Remove selected shipment detail.", '', 'question').then(() => {
        this.shipmentData.splice(index, 1);
        this.form.skulist.splice(index, 1);
        this.form.otherskuname.splice(index, 1);
        this.form.otherboxname.splice(index, 1);
        //this.form.boxlist.splice(index, 1);
        this.form.boxtype.splice(index, 1);
        this.form.hsn.splice(index, 1);
        this.form.boxdimension.splice(index, 1);
        this.form.averagephysicalweight.splice(index, 1);
        this.form.averagevolumetricweight.splice(index, 1);
        this.form.noofboxes.splice(index, 1);
        this.selectedboxtype.splice(index,1);
        this.selectedproduct.splice(index,1);
        this.clientboxtypelist.splice(index, 1);
        // this.otherbox.splice(index, 1);
        this.otherproduct.splice(index, 1);
      });
    },
    resetData() {
      this.clientid = '';
      this.ClientUOM = '';
      this.cbid = '';
      this.ActiveContract = '';
      this.TruckLoadType = 'PTL';
      this.RouteMode = 'Surface';
      this.BookingMode = 'Credit';
      this.PickupPincode = '';
      this.DestinationPincode = '';
      this.OriginHub = '';
      this.OriginHubId = '';
      this.DestinationHub = '';
      this.DestinationHubId = '';
      this.City = '';
      this.State = '';
      this.PinCode = '';
      this.Locationlist = [];
      this.Location = null;
      this.LocationName = null;
      this.Mobile = '';
      this.Telephone = '';
      this.Email = '';
      this.Address = '';
      this.GstNo = '';
      this.ShipmentDropByClient = '';
      this.NumberOfMPS = '';
      this.TotalShipmentValue = '';
      this.TotalShipmentWeight = '';
      this.RequestedPickupDate = Util.getCurrentDateOnly();
      this.NumberOfInvoice = '';
      this.RequestedPickupTimeFrom = new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      this.RequestedPickupTimeTo = '23:59';
      let shipmentDataArr = [];
      shipmentDataArr.push({
        skulist: null,
        hsn: '',
        boxtype: null,
        boxdimension: '',
        averagephysicalweight: '',
        averagevolumetricweight: '',
        noofboxes: '',
      });
      this.shipmentData = shipmentDataArr;
      this.form.skulist = [];
      this.form.skulistError = [];
      this.form.hsn = [];
      this.form.boxtype = [];
      this.form.boxlist = [];
      this.form.boxtypeError = [];
      this.form.boxdimension = [{
        length: '',
        breadth: '',
        height: ''
      }];
      this.form.averagephysicalweight = [];
      this.form.averagevolumetricweight = [];
      this.form.noofboxes = [];
      this.form.noofboxesError = [];
      this.SKUlist = [];
      this.manifestMethods = [];
      this.PickupPincodeServicable = 2;
      this.DestinationPincodeServicable = 2;
      this.AddNewLocationFlag = false;
      this.editGSTNo = false;
      this.editServicabilityflag = false;
      this.editBasicDetailsflag = false;
      this.subtabdisabledflag = true;
      this.clientboxtypelist= [];
      this.clientproductlist=[];
      this.selectedboxtype= [];
      this.selectedproduct= [];
      this.clientboxtypelistall= [];
      this.clientproductlistall= [];
      this.boxTypeshow= false;
      this.otherproduct= [];
      this.otherbox= [];
      this.collapseAll();
    },
    childMethod(tabtype, subtabid, clientid, pickuppincode, location, clientbusinessaccountid) {
      this.subtabdisabledflag = false;
      if (this.RouteMode == 'Air' && this.BookingMode == 'PrePaid') {
        this.ShipmentDropByClient = true;
        this.disableShipmentDropByClient = true;
      }
      if (tabtype == 'subtab') {
        this.accordianTab[subtabid] = true;
        this.toggleCheck(subtabid);
        if (clientid && this.SKUlist.length == 0) {
          this.getSKUList(clientid, clientbusinessaccountid);
        }
        if (!location && pickuppincode && clientid) {
          this.AddNewLocationFlag = false;
          this.editGSTNo = false;
          this.getPickupLocationList(clientid, pickuppincode, clientbusinessaccountid);
          this.isCargoAirShipment = true;
        }
        if (location) {
          this.AddNewLocationFlag = false;
          this.editGSTNo = false;
          if (location.id && location.id != "") {
            this.Location = location;
          } else {
            this.Location = null;
            // this.Mobile = "";
            // this.Telephone = "";
            // this.Email = "";
            this.Address = "";
            // this.GstNo = "";
          }
          this.getPickupLocationList(clientid, pickuppincode, clientbusinessaccountid);
          if(this.bookingData.bookingmethod == "App" && this.bookingData.totalshipmentvalues==null){
            this.editShipmentValue = false;
          }
        }
        this.getMaxVolumetricWeight();
       this.getClientBoxTypeList(clientid, clientbusinessaccountid);
      } else if (tabtype == 'maintab') {
        this.$emit("saveandnext", {});
      }
    },
    validateShipmentDetails(index) {
      this.$validator.validateAll("shipmentdetailsform").then((result) => {
        if (result) {
          this.addNewRow(index);
        } else {
          return false;
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    setVolumetricWt(id) {
      let uomdivisor = 27000;
      let avgvolumetricwt = ((parseFloat(this.form.boxdimension[id].length) * parseFloat(this.form.boxdimension[id].breadth) * parseFloat(this.form.boxdimension[id].height)) / uomdivisor) * this.actualwtconfigparam.agreedwtcft;
      if (isNaN(avgvolumetricwt)) {
        this.form.averagevolumetricweight[id] = "";
      } else {
        this.form.averagevolumetricweight[id] = parseFloat(avgvolumetricwt).toFixed(3);
      }
    },
    async selectedbox(id) {
      this.form.boxdimension[id] = {
        length: '',
        breadth: '',
        height: '',
      };
      this.form.averagevolumetricweight[id] = '';
      this.form.averagephysicalweight[id] = '';
      this.form.otherboxname[id] = '';
      if (this.form.boxtype[id] != "Other") {
        if (this.form.boxtype[id] != null) {
          this.form.boxtypeError[id] = "";
          let boxDetails = {}
          boxDetails = await this.setBoxDataValues(this.form.boxtype[id], this.form.boxtypeforother);
          this.form.boxdimension[id] = {
            length: boxDetails.dimension.L,
            breadth: boxDetails.dimension.B,
            height: boxDetails.dimension.H,
          };
          let uomdivisor = 27000;
          let avgvolwt = ((boxDetails.dimension.L * boxDetails.dimension.B * boxDetails.dimension.H) / uomdivisor) * this.actualwtconfigparam.agreedwtcft;
          this.form.averagevolumetricweight[id] = parseFloat(avgvolwt).toFixed(3);
        } else {
          this.form.boxtypeError[id] = "Please select box";
        }
      }
    },
    async setBoxDataValues(boxname, boxdata) {
      for (var i = 0; i < boxdata.length; i++) {
        if (boxdata[i].label == boxname) {
          return boxdata[i];
        }
      }
    },
    checkBoxNo(id) {
      if (this.form.noofboxes[id] != "") {
        this.form.noofboxesError[id] = "";
      } else {
        this.form.noofboxesError[id] = "Please enter No of Boxes";
      }
    },
    async getPickupLocationList(clientid, pickuppincode, clientbusinessaccountid) {
      try {
        this.Locationlist = [];
        let InputPayload = {
          clientid: clientid,
          pincode: pickuppincode,
          clientbusinessaccountid: clientbusinessaccountid
        }        
        this.isBasicInfoLoading = true;
        let result = await BookingService.getPickupLocationList(InputPayload);
        let locationdata = result.data.data;
        for (var i = 0; i < locationdata.length; i++) {
          this.Locationlist.push({
            'id': locationdata[i].locationname,
            'label': locationdata[i].locationname,
            'mobile': locationdata[i].mobile,
            'telephone': locationdata[i].telephone,
            'email': locationdata[i].email,
            'address': locationdata[i].address,
            'gstno': locationdata[i].gstno
          })
        }
        if (this.Locationlist.length == 1 && this.Location == null && !this.ShipmentDropByClient) {
          this.Location = this.Locationlist[0];
          this.Mobile = this.Locationlist[0].mobile;
          this.Telephone = this.Locationlist[0].telephone;
          this.Email = this.Locationlist[0].email;
          this.Address = this.Locationlist[0].address;
          this.GstNo = this.Locationlist[0].gstno
        }
        this.isBasicInfoLoading = false;
      } catch (err) {
        console.log(err);
        this.isBasicInfoLoading = false;
      }
    },
    async getClientUOM(clientid, clientbusinessaccountid) {
      try {
        this.isBasicInfoLoading = true;
        let InputPayload = {
          clientid: clientid,
          clientbusinessaccountid: clientbusinessaccountid
        }
        let result = await ClientService.getClientUOM(InputPayload);
        this.ClientUOM = result.data.data.uom;
        this.manifestMethods = result.data.data.manifestdatauploadmethod;
        this.cbid = result.data.data.cbid;
        this.ratetemplate =  result.data.data.ratetemplate;
		    this.awbSeries = result.data.data.awbSeries;
        this.isBasicInfoLoading = false;
      } catch (err) {
        this.isBasicInfoLoading = false;
        console.log(err);
      }
    },
    async getMaxVolumetricWeight(type) {
      try {
        this.isBasicInfoLoading = true;
        let InputPayload = {
          key : "MAXVOLWT"
        }
        let InputPayloadPhyWt = {
          key : "MAXPHYWT"
        }
        let result = await BookingService.GetConfigDetailsFromKey(InputPayload);
        let physicalWeightResult = await BookingService.GetConfigDetailsFromKey(InputPayloadPhyWt);
        this.MaxVolumetricWeight = result.data.data.value[0];
        this.MaxTotalVolumetricWeight = result.data.data.value[1]
        this.MaxTotalPhysicalWeight = physicalWeightResult.data.data.value[1]
        this.MaxAveragePhysicalWeight = physicalWeightResult.data.data.value[0]
        this.isBasicInfoLoading = false;
        if(type == "total"){
          return result.data.data.value[1]
        }
      } catch (err) {
        this.isBasicInfoLoading = false;
        console.log(err);
      }
    },
    async getSKUList(clientid, clientbusinessaccountid, contractid) {
      try {
        if (clientid) {
          this.clientid = clientid;
          this.clientbusinessaccid = clientbusinessaccountid;
          if (contractid) {
            this.ActiveContract = contractid;
          }
        }
        // this.isBasicInfoLoading = true;
        // this.SKUData = [];
        // this.SKUlist = [];
        // let InputPayload = {
        //   clientid: clientid,
        //   clientbusinessaccountid: clientbusinessaccountid
        // }
        // let result = await ClientService.getClientSKUList(InputPayload);
        // let skudata = result.data.data;
        // let tempArr = []
        // skudata.forEach((el) => {
        //   tempArr.push({
        //     'id': el.boxtype,
        //     'label': el.boxtype,
        //     'cft': el.cft,
        //     'dimension': el.dimension,
        //     'stackinglevel': el.stackinglevel,
        //   });
        // });
        // let mymap = new Map();
        // let unique = tempArr.filter(el => {
        //   const val = mymap.get(el.id);
        //   if (val) {
        //     if (el.label < val) {
        //       mymap.delete(el.id);
        //       mymap.set(el.id, el.label, el.cft, el.dimension, el.stackinglevel);
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   }
        //   mymap.set(el.id, el.label, el.cft, el.dimension, el.stackinglevel);
        //   return true;
        // });
        // unique.push({
        //   id: "Other",
        //   label: "Other"
        // })
        // this.form.boxtypeforother = unique;
        // this.SKUData = this.groupBy(skudata, "productcategory");
        // for (var key in this.SKUData) {
        //   this.SKUlist.push({
        //     'id': this.SKUData[key][0].productcategory,
        //     'label': this.SKUData[key][0].productcategory,
        //     'hsn': this.SKUData[key][0].hsn,
        //   });
        // }
        // this.SKUlist.push({
        //   'id': "Other",
        //   'label': "Other",
        //   'hsn': "",
        // });
        // this.isBasicInfoLoading = false;
      } catch (err) {
        this.isBasicInfoLoading = false;
        console.log(err);
      }
    },
    groupBy(array, property) {
      var hash = {};
      for (var i = 0; i < array.length; i++) {
        if (!hash[array[i][property]]) hash[array[i][property]] = [];
        hash[array[i][property]].push(array[i]);
      }
      return hash;
    },
    getBoxTypeList(id) {
      try {
        this.form.boxlist[id] = [];
        if (this.form.skulist[id] != null) {
          let product = this.form.skulist[id];
          let dataArray = this.SKUData[product];
          let tempArr = [];
          if (dataArray && dataArray.length > 0) {
            dataArray.forEach((el) => {
              tempArr.push({
                'id': el.boxtype,
                'label': el.boxtype,
                'cft': el.cft,
                'dimension': el.dimension,
                'stackinglevel': el.stackinglevel,
              });
            });
          }
          tempArr.push({
            id: "Other",
            label: "Other"
          })
          this.form.boxlist[id] = tempArr;
        }
      } catch (err) {
        console.log(err);
      }
    },

    expandAll() {
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll() {
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid) {
      this.expanded = false;
      for (var key in this.accordianTab) {
        if (tabid != key) {
          this.accordianTab[key] = false;
        }
      }
    },
    async getBookingDetails(bookingid) {
      try {
        this.basicInformationData = [];
        let InputPayload = {
          bookingid: bookingid
        }
        this.isBasicInfoLoading = true;
        let response = await BookingService.getBookingDetails(InputPayload);
        this.basicInformationData = response.data.data;
        this.setValues();
      } catch (err) {
        this.isBasicInfoLoading = false;
        console.log(err);
      }
    },
    setValues() {
      this.TruckLoadType = this.basicInformationData.truckloadtype;
      this.RouteMode = this.basicInformationData.routemode;
      this.BookingMode = this.basicInformationData.bookingmode;
      this.PickupPincode = this.basicInformationData.pickuppincode;
      this.DestinationPincode = this.basicInformationData.destinationpincode;
      this.OriginHub = this.basicInformationData.originhub;
      this.OriginHubId = this.basicInformationData.originhubid;
      this.DestinationHub = this.basicInformationData.destinationhubs;
      this.DestinationHubId = this.basicInformationData.destinationhubid;
      this.City = this.basicInformationData.pickupcity;
      this.State = this.basicInformationData.pickupstate;
      this.ConsigneeCity = this.basicInformationData.consingneecity;
      this.ConsigneeState = this.basicInformationData.consingneestate;
      this.PinCode = this.basicInformationData.pickuppincode;
      if (this.basicInformationData.pickuplocationname) {
        this.Location = {
          id: this.basicInformationData.pickuplocationname,
          label: this.basicInformationData.pickuplocationname,
          mobile: this.basicInformationData.pickupmobile,
          telephone: this.basicInformationData.pickuptelephone,
          email: this.basicInformationData.pickupemail,
          address: this.basicInformationData.pickupaddress,
          gstno: this.basicInformationData.pickupgst
        };
      }if(this.basicInformationData.dropbyclient ==1){
       this.Mobile = this.basicInformationData.pickupmobile
       this.Telephone = this.basicInformationData.pickuptelephone
       this.Email = this.basicInformationData.pickupemail
       this.GstNo = this.basicInformationData.pickupgst
      }
      this.ShipmentDropByClient = this.basicInformationData.dropbyclient;
      if (this.RouteMode == 'Air' && this.BookingMode == 'PrePaid') {
        this.ShipmentDropByClient = true;
        this.disableShipmentDropByClient = true;
      }
      this.NumberOfMPS = this.basicInformationData.numberofmps;
      this.TotalShipmentValue = this.basicInformationData.totalshipmentvalues;
      this.TotalShipmentWeight = this.basicInformationData.totalphysicalweight;
      if (this.basicInformationData.requestedpickupdate) {
        this.RequestedPickupDate = this.basicInformationData.requestedpickupdate;
      }
      this.NumberOfInvoice = this.basicInformationData.numberofinvoices;
      if (this.basicInformationData.requestedpickuptimefrom) {
        this.RequestedPickupTimeFrom = this.basicInformationData.requestedpickuptimefrom;
      }
      if (this.basicInformationData.requestedpickuptimeto) {
        this.RequestedPickupTimeTo = this.basicInformationData.requestedpickuptimeto;
      }
      this.actualwtconfigparam = this.basicInformationData.actualwtconfigparam;

      let shipmentdata = this.basicInformationData.shipmentdetails;
      if (shipmentdata && shipmentdata.length > 0) {
        let shipmentDataArr = [];
        shipmentdata.forEach((item, index) => {
          this.form.skulist[index] = item.skulist;
          this.form.otherskuname[index] = item.otherskuname;
          this.form.otherboxname[index] = item.otherboxname;
          this.form.skulistError[index + 1] = "";
          this.form.hsn[index] = item.hsn;
          this.form.boxtype[index] = item.boxtype;
          this.form.boxtypeError[index + 1] = "";
          this.form.boxdimension[index] = item.boxdimension;
          this.form.averagephysicalweight[index] = item.averagephysicalweight;
          this.form.averagevolumetricweight[index] = item.averagevolumetricweight;
          this.form.noofboxes[index] = item.noofboxes;
          this.form.noofboxesError[index + 1] = '';
          this.setBoxProduct(item, index);
        });
        shipmentdata.forEach(function(item) {
          shipmentDataArr.push({
            skulist: item.skulist,
            hsn: item.hsn,
            boxtype: item.boxtype,
            boxdimension: item.boxdimension,
            averagephysicalweight: item.averagephysicalweight,
            averagevolumetricweight: item.averagevolumetricweight,
            noofboxes: item.noofboxes,
            uom: item.uom
          });
        });
        this.shipmentData = shipmentDataArr;
      } else {
        let shipmentDataArr = [];
        shipmentDataArr.push({
          skulist: '',
          hsn: '',
          boxtype: '',
          boxdimension: '',
          averagephysicalweight: '',
          averagevolumetricweight: '',
          noofboxes: '',
        });
        this.shipmentData = shipmentDataArr;
        this.form.skulist[0] = null;
        this.form.skulistError[0] = '';
        this.form.hsn[0] = '';
        this.form.boxtype[0] = null;
        this.form.boxlist[0] = [];
        this.form.boxtypeError[0] = '';
        this.form.boxdimension[0] = {
          length: '',
          breadth: '',
          height: ''
        };
        this.form.averagephysicalweight[0] = '';
        this.form.averagevolumetricweight[0] = '';
        this.form.noofboxes[0] = '';
        this.form.noofboxesError[0] = '';
      }
    },
    checkServiceabilityValidation() {
      if (this.pincodeservicabilitycheckflag == true) {
        this.$validator.validateAll("serviceabilityform").then(async (result) => {
          if (result) {
            var inputPayload = {};
            inputPayload.TruckLoadType = this.TruckLoadType;
            inputPayload.RouteMode = this.RouteMode;
            inputPayload.BookingMode = this.BookingMode;
            inputPayload.PickupPincode = this.PickupPincode;
            inputPayload.DestinationPincode = this.DestinationPincode;
            inputPayload.OriginHub = this.OriginHub;
            inputPayload.OriginHubId = this.OriginHubId;
            inputPayload.DestinationHub = this.DestinationHub;
            inputPayload.DestinationHubId = this.DestinationHubId;
            inputPayload.City = this.City;
            inputPayload.State = this.State;
            inputPayload.ConsigneeCity = this.ConsigneeCity;
            inputPayload.ConsigneeState = this.ConsigneeState;
            inputPayload.actualwtconfigparam = this.actualwtconfigparam;
            inputPayload.lastmodifiedby = this.userName;
            if (this.RouteMode == 'Air' && this.BookingMode == 'PrePaid') {
              inputPayload.businesstype  = this.businesstype.id;
              inputPayload.airlinename =   this.airlinename.id;
              inputPayload.producttype =   this.producttype.id;
              inputPayload.flighttype =    this.flighttype.id;
              inputPayload.cbid =          this.cbid;
            }
            this.editBasicDetailsflag =true;
            await this.$emit("savebooking", inputPayload, "saveServiceability",this.awbSeries);
            this.editBasicDetailsflag =false;
          }
        }).catch((err) => {
          console.log('errors exist',err);
          return false;
        });
      } else {
        this.$alert("Please check pickup & destination Pincode serviceability", "", "error");
      }
    },
    checkPickupLocationValidation() {
      if (this.pincodeservicabilitycheckflag == true) {
        this.$validator.validateAll("pickuplocationform").then(async (result) => {
          if (result) {
            var inputPayload = {};
            if (this.AddNewLocationFlag == true) {
              inputPayload.LocationName = this.LocationName;
              inputPayload.PickupPincode = this.bookingData.pickuppincode;
            } else {
              inputPayload.LocationId = (this.ShipmentDropByClient == false ? this.Location.id : null);
              inputPayload.LocationName = (this.ShipmentDropByClient == false ? this.Location.label : "");
            }
			      inputPayload.bookingid = this.bookingData.id
			      inputPayload.RouteMode = this.RouteMode
            inputPayload.Mobile =  this.Mobile;
            inputPayload.Telephone =  this.Telephone ;
            inputPayload.Email =  this.Email;
            inputPayload.Address = (this.ShipmentDropByClient == false ? this.Address: "");
            inputPayload.GstNo =  this.GstNo;
            inputPayload.ShipmentDropByClient = (this.ShipmentDropByClient == true ? 1 : 0);
            inputPayload.lastmodifiedby = this.userName;
            inputPayload.editPickupLocation = this.editPickupLocation
            this.editBasicDetailsflag =true;
            await this.$emit("savebooking", inputPayload, "savePickupLocation",this.awbSeries);
            if(this.bookingData.bookingmethod == "Upload" && this.bookingData.totalvolumetricweight == null){
              this.editShipmentDimensions = false;
            }
            this.editBasicDetailsflag =this.editGSTNo?true:false;
          }
        }).catch((err) => {
          console.log('errors exist',err);
          return false;
        });
      } else {
        this.$alert("Please check pickup & destination Pincode serviceability", "", "error");
      }
    },
    checkShipmentTotalValidation(){
      this.$validator.validateAll("shipmentdetailsform").then(async (result) => {
        if (result) {
          var inputPayload = {};
          inputPayload.bookingid = this.bookingData.id;
          inputPayload.TotalShipmentValue = this.TotalShipmentValue;
          inputPayload.lastmodifiedby = this.userName;
          this.editBasicDetailsflag =true;
          await this.$emit("savebooking", inputPayload, "saveShipmentTotal",this.awbSeries);
          this.editBasicDetailsflag =false;
        }
      }).catch((err) => {
        console.log('errors exist',err);
        return false;
      });
    },
    checkShipmentDimensions(){
      this.$validator.validateAll("shipmentdetailsform").then(async (result) => {
        if (result) {
          var inputPayload = {};
          inputPayload.bookingid = this.bookingData.id;
          let shipmentdetails = [];
          let noofboxesCount = 0;
          let totalvolumetricweight = 0;
          //let totalphysicalweight = 0;
          let avgphysicalwt = parseFloat(this.TotalShipmentWeight) / parseFloat(this.NumberOfMPS)
          for (var i = 0; i < this.form.noofboxes.length; i++) {
            shipmentdetails.push({
              skulist: this.form.skulist[i] ? this.form.skulist[i] : 'Other',
              otherskuname: this.form.otherskuname[i] ? this.form.otherskuname[i] : '',
              otherboxname: this.form.otherboxname[i] ? this.form.otherboxname[i] : '',
              hsn: null,
              boxtype: this.form.boxtype[i] ? this.form.boxtype[i] : 'Other',
              boxdimension: this.form.boxdimension[i],
              averagephysicalweight: (avgphysicalwt).toFixed(3),
              averagevolumetricweight: this.form.averagevolumetricweight[i],
              noofboxes: this.form.noofboxes[i],
              uom: 'cm'
            });
            if (this.form.averagevolumetricweight[i] > this.MaxVolumetricWeight) {
              this.accordianTab[3] = true;
              this.$alert("Volumetric Weight must be less than "+ this.MaxVolumetricWeight + " Kg per MPS", "", "error");
              return false;
            }
            noofboxesCount = noofboxesCount + parseInt(this.form.noofboxes[i]);
            totalvolumetricweight = totalvolumetricweight + (this.form.averagevolumetricweight[i] * this.form.noofboxes[i]);
          }
          if (noofboxesCount != parseInt(this.NumberOfMPS)) {
            this.accordianTab[3] = true;
            this.$alert("Number of MPS & Total Number of boxes are not matched.", "", "error");
            return false;
          }
          if (totalvolumetricweight > this.MaxTotalVolumetricWeight) {
            this.accordianTab[3] = true;
            this.$alert("Total Volumetric Weight must be less than "+ this.MaxTotalVolumetricWeight + " Kg", "", "error");
            return false;
          }
          if (this.TotalShipmentWeight > this.MaxTotalPhysicalWeight) {
            this.accordianTab[3] = true;
            $("#TotalShipmentWeight").addClass('error');
            this.$alert("Physical Weight must be less than "+ this.MaxTotalPhysicalWeight + " Kg", "", "error");
            return false;
          }
          if (avgphysicalwt > this.MaxAveragePhysicalWeight) {
            this.accordianTab[3] = true;
            this.$alert("Average Physical Weight per MPS must be less than "+ this.MaxAveragePhysicalWeight + " Kg", "", "error");
            return false;
          }
          inputPayload.ShipmentDetails = shipmentdetails;
          inputPayload.NumberOfMPS = this.NumberOfMPS;
          inputPayload.totalvolumetricweight = totalvolumetricweight;
          inputPayload.totalphysicalweight = this.TotalShipmentWeight;
          inputPayload.TotalShipmentValue = this.TotalShipmentValue;
          inputPayload.lastmodifiedby = this.userName;
          this.editShipmentDimensions =true;
          await this.$emit("savebooking", inputPayload, "saveShipmentDimensions",this.awbSeries);
          this.editBasicDetailsflag =false;
        }
      }).catch((err) => {
        console.log('errors exist',err);
        return false;
      });
    },
    checkShipmentDetailsValidation() {
      if (this.pincodeservicabilitycheckflag == true) {
        this.$validator.validateAll("shipmentdetailsform").then((result) => {
          if (result) {
            var totime = this.RequestedPickupTimeTo.split(':');
            var fromtime = this.RequestedPickupTimeFrom.split(':');
            let totalToTimeSeconds = parseInt(totime[0] * 3600 + totime[1] * 60);
            let totalFromTimeSeconds = parseInt(fromtime[0] * 3600 + fromtime[1] * 60);
            if (totalToTimeSeconds <= totalFromTimeSeconds) {
              this.$alert("Requested pickup To time should be greater than From time", "", "error");
              $("#RequestedPickupTimeTo").addClass('error');
            } else {
              $("#RequestedPickupTimeTo").removeClass('error');
              $("#RequestedPickupTimeFrom").removeClass('error');
              this.saveBasicInformation();
            }
          }
        }).catch(() => {
          console.log('errors exist');
          return false;
        });
      } else {
        this.$alert("Please check pickup & destination Pincode serviceability", "", "error");
      }
    },
    ValidateTime() {
      var totime = this.RequestedPickupTimeTo.split(':');
      var fromtime = this.RequestedPickupTimeFrom.split(':');
      let totalToTimeSeconds = parseInt(totime[0] * 3600 + totime[1] * 60);
      let totalFromTimeSeconds = parseInt(fromtime[0] * 3600 + fromtime[1] * 60);
      if (totalToTimeSeconds <= totalFromTimeSeconds) {
        $("#RequestedPickupTimeTo").addClass('error');
      } else if (this.todaysDate == this.RequestedPickupDate) {
        this.RequestedPickupTimeFrom = new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      } else {
        this.RequestedPickupTimeFrom = "00:00"
        $("#RequestedPickupTimeTo").removeClass('error');
        $("#RequestedPickupTimeFrom").removeClass('error');
      }
    },
    async saveBasicInformation() {
      if (this.pincodeservicabilitycheckflag == false) {
        this.accordianTab[1] = true;
        this.$alert("Please check pickup & destination Pincode serviceability", "", "error");
        return false;
      } else if (this.PickupPincodeServicable != 1 && this.DestinationPincodeServicable != 1) {
        this.accordianTab[1] = true;
        return false;
      }

      let servicability = await this.$validator.validateAll("serviceabilityform").then((result) => {
        return result
      });
      let pickuplocation = await this.$validator.validateAll("pickuplocationform").then((result) => {
        return result
      });
      let shipmentdetails = await this.$validator.validateAll("shipmentdetailsform").then((result) => {
        return result
      });

      if (!servicability) {
        this.accordianTab[1] = true;
      } else {
        this.accordianTab[1] = false;
      }
      if (!pickuplocation) {
        this.accordianTab[2] = true;
      } else {
        this.accordianTab[2] = false;
      }
      if (!shipmentdetails) {
        this.accordianTab[3] = true;
      } else {
        this.accordianTab[3] = false;
      }

      var totime = this.RequestedPickupTimeTo.split(':');
      var fromtime = this.RequestedPickupTimeFrom.split(':');
      let totalToTimeSeconds = parseInt(totime[0] * 3600 + totime[1] * 60);
      let totalFromTimeSeconds = parseInt(fromtime[0] * 3600 + fromtime[1] * 60);
      if (totalToTimeSeconds <= totalFromTimeSeconds) {
        this.$alert("Requested pickup To time should be greater than From time", "", "error");
        this.accordianTab[3] = true;
        $("#RequestedPickupTimeTo").addClass('error');
        return false;
      }
      if (servicability && pickuplocation && shipmentdetails) {
        var inputPayload = {};
        inputPayload.TruckLoadType = this.TruckLoadType;
        inputPayload.RouteMode = this.RouteMode;
        inputPayload.BookingMode = this.BookingMode;
        inputPayload.PickupPincode = this.PickupPincode;
        inputPayload.DestinationPincode = this.DestinationPincode;
        inputPayload.OriginHub = this.OriginHub;
        inputPayload.OriginHubId = this.OriginHubId;
        inputPayload.DestinationHub = this.DestinationHub;
        inputPayload.DestinationHubId = this.DestinationHubId;
        inputPayload.City = this.City;
        inputPayload.State = this.State;
        inputPayload.ConsigneeCity = this.ConsigneeCity;
        inputPayload.ConsigneeState = this.ConsigneeState;
        inputPayload.lastmodifiedby = this.userName;
		    inputPayload.bookingid = this.bookingData.id

        if (this.AddNewLocationFlag == true) {
          inputPayload.LocationName = this.LocationName;
          inputPayload.PickupPincode = this.bookingData.pickuppincode;
        } else {
          inputPayload.LocationId = (this.ShipmentDropByClient == false ? this.Location.id : null);
          inputPayload.LocationName = (this.ShipmentDropByClient == false ? this.Location.label : "");
        }
        inputPayload.Mobile =  this.Mobile;
        inputPayload.Telephone = this.Telephone ;
        inputPayload.Email =  this.Email;
        inputPayload.Address = (this.ShipmentDropByClient == false ? this.Address: "");
        inputPayload.GstNo = this.GstNo;
        inputPayload.ShipmentDropByClient = (this.ShipmentDropByClient == true ? 1 : 0);

        inputPayload.NumberOfMPS = this.NumberOfMPS;
        inputPayload.TotalShipmentValue = this.TotalShipmentValue;
        inputPayload.RequestedPickupDate = this.RequestedPickupDate;
        inputPayload.NumberOfInvoice = this.NumberOfInvoice;
        inputPayload.RequestedPickupTimeFrom = "00:00";
        inputPayload.RequestedPickupTimeTo = "23:59";
        if (this.RequestedPickupDate == this.todaysDate) {
          inputPayload.RequestedPickupTimeFrom = new Date().toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          });
        }
        let shipmentdetails = [];
        let noofboxesCount = 0;
        let totalvolumetricweight = 0;
        //let totalphysicalweight = 0;
        let avgphysicalwt = parseFloat(this.TotalShipmentWeight) / parseFloat(this.NumberOfMPS)
        for (var i = 0; i < this.form.noofboxes.length; i++) {
          shipmentdetails.push({
            skulist: this.form.skulist[i] ? this.form.skulist[i] : 'Other',
            otherskuname: this.form.otherskuname[i] ? this.form.otherskuname[i] : '',
            otherboxname: this.form.otherboxname[i] ? this.form.otherboxname[i] : '',
            hsn: null,
            boxtype: this.form.boxtype[i] ? this.form.boxtype[i] : 'Other',
            boxdimension: this.form.boxdimension[i],
            averagephysicalweight: (avgphysicalwt).toFixed(3),
            averagevolumetricweight: this.form.averagevolumetricweight[i],
            noofboxes: this.form.noofboxes[i],
            //uom: this.ClientUOM
            uom: 'cm'

          });
          if (this.form.averagevolumetricweight[i] > this.MaxVolumetricWeight) {
            this.accordianTab[3] = true;
            this.$alert("Volumetric Weight must be less than "+ this.MaxVolumetricWeight + " Kg per MPS", "", "error");
            return false;
          }
          noofboxesCount = noofboxesCount + parseInt(this.form.noofboxes[i]);
          totalvolumetricweight = totalvolumetricweight + (this.form.averagevolumetricweight[i] * this.form.noofboxes[i]);
          //totalphysicalweight = totalphysicalweight + (this.form.averagephysicalweight[i]*this.form.noofboxes[i]);
        }
        if (totalvolumetricweight > this.MaxTotalVolumetricWeight) {
          this.accordianTab[3] = true;
          this.$alert("Total Volumetric Weight must be less than "+ this.MaxTotalVolumetricWeight + " Kg", "", "error");
          return false;
        }
        if (this.TotalShipmentWeight > this.MaxTotalPhysicalWeight) {
          this.accordianTab[3] = true;
          $("#TotalShipmentWeight").addClass('error');
          this.$alert("Physical Weight must be less than "+ this.MaxTotalPhysicalWeight + " Kg", "", "error");
          return false;
        }
        if (avgphysicalwt > this.MaxAveragePhysicalWeight) {
          this.accordianTab[3] = true;
          this.$alert("Average Physical Weight per MPS must be less than "+ this.MaxAveragePhysicalWeight + " Kg", "", "error");
          return false;
        }
        inputPayload.ShipmentDetails = shipmentdetails;
        inputPayload.totalvolumetricweight = totalvolumetricweight;
        inputPayload.totalphysicalweight = this.TotalShipmentWeight;

        if (this.PickupPincodeServicable != 1 && this.DestinationPincodeServicable != 1) {
          this.accordianTab[1] = true;
          this.$alert("Please check Pickup & Destination Pincodes Servicability", "", "error");
          return false;
        } else if (noofboxesCount != parseInt(this.NumberOfMPS)) {
          this.accordianTab[3] = true;
          this.$alert("Number of MPS & Total Number of boxes are not matched.", "", "error");
          return false;
        }
        //  else if (parseInt(this.NumberOfInvoice) > parseInt(this.NumberOfMPS)) {
        //   this.accordianTab[3] = true;
        //   this.$alert("Total Number of Invoice should not be greater than Total Number of MPS", "", "error");
        //   return false;
        // }
        else {
          if (this.RouteMode == 'Air' && this.BookingMode == 'PrePaid') {
            let rateresult = await this.getAirCargoRates(totalvolumetricweight)
            if (!rateresult) {
              return false;
            }
            document.activeElement.blur();
            let totalcharges = this.airCargobillData.rate.basefreight
            + this.airCargobillData.rate.originterminalcharges
            + this.airCargobillData.rate.destinationterminalcharges
            + this.airCargobillData.rate.originoperatorcharges
            + this.airCargobillData.rate.destinationoperatorcharges
            + this.airCargobillData.rate.othercharges
            + this.airCargobillData.rate.extracharges

            let gst = totalcharges / 100 *this.airCargobillData.rate.gst ;
            let message = ` <div class="col-md-8-text-center" style="padding-top: 50px;">
            <table class="table-bordered table-hover tbl datatables" style="width:100%;">
                <tr class="text-primary">
                  <th class="text-center tableheader">Base Freight</th>
                  <td class="text-center">${parseFloat(this.airCargobillData.rate.basefreight).toFixed(2)}</td>
                </tr>
                <tr class="text-primary">
                <th class="text-center tableheader">Origin Terminal charges </th>
                <td class="text-center">${parseFloat(this.airCargobillData.rate.originterminalcharges).toFixed(2)}</td>
              </tr>
              <tr class="text-primary">
                <th class="text-center tableheader">Destination Terminal Charges </th>
                <td class="text-center">${parseFloat(this.airCargobillData.rate.destinationterminalcharges).toFixed(2)}</td>
              </tr>
              <tr class="text-primary">
              <th class="text-center tableheader">Other Charges </th>
              <td class="text-center">${parseFloat(this.airCargobillData.rate.othercharges).toFixed(2)}</td>
            </tr>
              <tr class="text-primary">
              <th class="text-center tableheader">Operator Charges origin </th>
              <td class="text-center">${parseFloat(this.airCargobillData.rate.originoperatorcharges).toFixed(2)}</td>
            </tr>
            <tr class="text-primary">
            <th class="text-center tableheader">Operator Charges destination </th>
            <td class="text-center">${parseFloat(this.airCargobillData.rate.destinationoperatorcharges.toFixed(2))}</td>
              </tr>
              <tr class="text-primary">
            <th class="text-center tableheader">Extra Charge </th>
            <td class="text-center">${parseFloat(this.airCargobillData.rate.extracharges).toFixed(2)}</td>
              </tr>
              <tr class="text-primary">
              <th class="text-center table-warning">Total Charge </th>
              <td class="text-center table-warning">${parseFloat(totalcharges).toFixed(2)}</td>
            </tr>
            <tr class="text-primary">
            <th class="text-center table-success">Total charges + GST (18%) </th>
            <td class="text-center table-success">${parseFloat(totalcharges + gst).toFixed(2)}</td>
             </tr>
            </table>
          </div>`
            this.$fire({
              html: message,
              textalign: 'center',
              showCancelButton: true,
              // cancelButtonColor: '#009C41',
              // confirmButtonColor: '#20a8d8',
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              reverseButtons: true
              }).then(async (rateresult) => {
                if (rateresult.value == true) {
                  let walletballance = await this.getWalletBalance()
                  if (walletballance.data.valid == 1) {
                    var message = ''
                    var availablebalance = parseFloat(walletballance.data.data.wallet_balance).toFixed(2)
                    var remainingBalance;
                    if (parseFloat(availablebalance) < parseFloat(totalcharges + gst)) {
                      var shouldShowConfirmButton = false;
                      message = 'Not enough balance to complete transaction'
                      remainingBalance = ''
                    }else{
                      var shouldShowConfirmButton = true;
                      var remainingBalance = parseFloat(parseFloat(availablebalance) - parseFloat(totalcharges + gst)).toFixed(2)
                    }
                  }else{
                    this.$alert(walletballance.data.error, "", "error");
                    this.accordianTab[1] = true;
                    return false;
                  }
                  this.$fire({
                    html: `<html lang="en">
                    <head>
                        <meta charset="UTF-8">
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        <title>Wallet Balance</title>
                        <style>
                            body {
                                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                                background-color: #f4f4f4;
                                margin: 0;
                                padding: 0;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                height: 100vh;
                            }
                            .container {
                                background-color: #fff;
                                border-radius: 8px;
                                padding: 20px;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                                width: 400px;
                            }
                            h1 {
                                color: #333;
                                text-align: center;
                            }
                            table {
                                width: 100%;
                                border-collapse: collapse;
                                margin-top: 15px;
                            }
                            tr {
                                border-bottom: 1px solid #ddd;
                            }
                            th, td {
                                padding: 15px;
                                text-align: left;
                            }
                            .green-text {
                                color: #28a745; /* Green color for available and remaining amounts */
                            }
                            .red-text {
                                color: #dc3545; /* Red color for amount to be deducted */
                            }
                        </style>
                    </head>
                    <body>

                        <div class="container">
                            <h3>Transaction Details</h3>

                            <table>
                                <tr>
                                    <th>Description</th>
                                    <th>Amount</th>
                                </tr>
                                <tr>
                                    <td>Available Balance:</td>
                                    <td class="green-text">₹<span id="availableBalance">${availablebalance}</span></td>
                                </tr>
                                <tr>
                                    <td>Amount to be Deducted:</td>
                                    <td class="red-text">₹<span id="amountToDeduct">${parseFloat(totalcharges + gst).toFixed(2)}</span></td>
                                </tr>
                                <tr>
                                    <td>Remaining Balance:</td>
                                    <td class="green-text">₹<span id="remainingBalance">${remainingBalance}</span></td>
                                </tr>
                                <tr rowspan = 2>
                                    <td class="red-text"><span id="amountToDeduct">${message}</span></td>
                                </tr>
                            </table>
                        </div>

                    </body>
                    </html>` ,
                    textalign: 'center',
                    showCancelButton: true,
                    showConfirmButton: shouldShowConfirmButton,
                    // cancelButtonColor: '#009C41',
                    // confirmButtonColor: '#20a8d8',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                    }).then(async(result)  => {
                      if(result.value == true) {
                        inputPayload.prepaidratebreakup = this.airCargobillData
                        this.editBasicDetailsflag =true;
                         this.$emit("savebooking", inputPayload, "saveBasicInformation",this.awbSeries,totalcharges + gst);
                        this.editBasicDetailsflag =false;

                      }else{
                        this.accordianTab[1] = true;
                        return false;
                      }
                    }).catch((err)=>{
                     console.log(err)
                   });
                }else{
                  this.accordianTab[1] = true;
                  return false;
                }
              }).catch((err)=>{
               console.log(err)
             });
          }else{
               this.editBasicDetailsflag =true;
             await this.$emit("savebooking", inputPayload, "saveBasicInformation",this.awbSeries);
             this.editBasicDetailsflag =false;

          }
        }
      }
    },
    async checkPincodeServicability() {
      try {
        if (this.clientid == "") {
          this.$alert("Please select Client", "", "error");
          return false;
        } else if (!this.manifestMethods.includes("ManualBooking")) {
          this.$alert("Manual Booking method was not configured for selected client.", "", "error");
        } else if (this.TruckLoadType == "") {
          this.$alert("Please select Truck Load Type", "", "error");
          return false;
        } else if (this.RouteMode == "") {
          this.$alert("Please select Route Mode", "", "error");
          return false;
        } else if (this.BookingMode == "") {
          this.$alert("Please select Booking Mode", "", "error");
          return false;
        } else if (!this.PickupPincode && this.DestinationPincode) {
          this.$alert("Please enter Pickup Pincode", "", "error");
          return false;
        } else if (this.PickupPincode && !this.DestinationPincode) {
          this.$alert("Please enter Destination Pincode", "", "error");
          return false;
        } else if (!this.PickupPincode && !this.DestinationPincode) {
          this.$alert("Please enter Pickup & Destination Pincodes", "", "error");
          return false;
        } else if (this.PickupPincode.length < 6 || this.DestinationPincode.length < 6) {
          return false;
        }else if (this.RouteMode == 'Air' && this.BookingMode == 'PrePaid' && this.cbid && !this.ratetemplate)  {
          this.$alert("Prepaid Rate template is not defined for this client. Please contact onboarding team", "", "error");
          return false;
        }
        else {
          var inputPayload = {};
          inputPayload.SourcePincode = this.PickupPincode.toString();
          inputPayload.DestinationPincode = this.DestinationPincode.toString();
          inputPayload.ClientId = this.clientid;
          inputPayload.ClientBusinessAccountId = this.clientbusinessaccid;
          inputPayload.TruckLoadType = this.TruckLoadType;
          inputPayload.RouteMode = this.RouteMode;
          inputPayload.BookingMode = this.BookingMode;
          if (this.RouteMode == 'Air' && this.BookingMode == 'PrePaid') {
            inputPayload.businesstype = this.businesstype.businesstype;
          }
          if (this.userRoleFlag == 1) {
            inputPayload.defaultHubID = this.defaultHubID;
          }
          this.isBasicInfoLoading = true;
          let result = await BookingService.checkPincodeServicability(inputPayload);
          this.isBasicInfoLoading = false;
          if(result.data.code == 199){
					  var WarningMsg = result.data.message;
					  this.$confirm(WarningMsg," ","info").then(()=>{
              this.isBasicInfoLoading = true;
							this.setpincodedata(result);
              this.isBasicInfoLoading = false;
						}).catch((err)=>{
              this.isBasicInfoLoading = false;
              this.PickupPincodeServicable = 0;
              this.DestinationPincodeServicable = 0;
              this.actualwtconfigparam = {};
              console.log(err);
					  });
					}else if(result.data.code == 200){
            this.isBasicInfoLoading = true;
            this.setpincodedata(result);
            this.isBasicInfoLoading = false;
          }else{
            this.actualwtconfigparam = {};
            this.$alert(result.data.message, "", "error");
            this.isBasicInfoLoading = false;
					}
        }
      } catch (err) {
        this.isBasicInfoLoading = false;
        this.$alert(err, "", "error");
        this.PickupPincodeServicable = 0;
        this.DestinationPincodeServicable = 0;
        console.log(err);
      }
    },
    setpincodedata(result){
      this.actualwtconfigparam = result.data.data.contractratedata;
      if (result.data.data.sourcepincodedata) {
        this.PickupPincodeServicable = 1;
        this.OriginHub = result.data.data.sourcepincodedata.HubName;
        this.OriginHubId = result.data.data.sourcepincodedata.HubID;
        this.PinCode = this.PickupPincode;
        this.State = result.data.data.sourcepincodedata.StateName;
        this.City = result.data.data.sourcepincodedata.CityName;
      } else {
        this.PickupPincodeServicable = 0;
        this.OriginHub = "";
        this.OriginHubId = "";
        this.PinCode = "";
        this.State = "";
        this.City = "";
      }
      if (result.data.data.destinationpincodedata) {
        this.DestinationPincodeServicable = 1;
        this.DestinationHub = result.data.data.destinationpincodedata.HubName;
        this.DestinationHubId = result.data.data.destinationpincodedata.HubID;
        this.ConsigneeState = result.data.data.destinationpincodedata.StateName;
        this.ConsigneeCity = result.data.data.destinationpincodedata.CityName;
      } else {
        this.DestinationPincodeServicable = 0;
        this.DestinationHub = "";
        this.DestinationHubId = "";
      }

      if (result.data.data.sourcepincodedata && result.data.data.destinationpincodedata) {
        this.pincodeservicabilitycheckflag = true;
      } else {
        if (result.data.data.sourcepincodeerror) {
          this.sourcepincodeerrmsg = result.data.data.sourcepincodeerror;
        }
        if (result.data.data.destinationpincodeerror) {
          this.destinationpincodeerrmsg = result.data.data.destinationpincodeerror;
        }
      }
    },
    removeWeightError(){
      $("#TotalShipmentWeight").removeClass('error');
    },
    inchtocm() {
      this.cm = this.inches * 2.54;
    },
    cmtoinch() {
      this.inches = this.cm / 2.54
    },
    openConverter() {
      this.convertermodal = true;
    },
    closeConverter() {
      this.convertermodal = false;
    },
    async getClientBoxTypeList(clientid, clientbusinessaccountid) {
      try {
        this.isLoading = true;
        let InputPayload = {
          clientid: clientid,
          clientbusinessaccountid: parseInt(clientbusinessaccountid)
        };
        let result = await ClientService.getAllClientBoxType(InputPayload);
        let tempBoxtypes = result.data.data.boxtype;
        let tempProducts = result.data.data.product;
        let boxtype = [];
        if (tempBoxtypes.length == 0) {
          this.boxTypeshow = false;
        } else {
          this.boxTypeshow = true;
          this.clientboxtypelist =[];
          this.clientboxtypelistall =[];
          this.clientproductlist=[];
          this.clientboxtypelistall=[];
          for (var i = 0; i < tempBoxtypes.length; i++) {
            let isdisabled = false;
            if(tempBoxtypes[i].status==0){
              isdisabled = true;
            }
            this.clientboxtypelistall.push({
              'id': tempBoxtypes[i].boxtypeid,
              'label': tempBoxtypes[i]['boxtypemaster.boxtype'],
              'product': tempBoxtypes[i]['boxtypemaster.product'],
              'dimension': tempBoxtypes[i]['boxtypemaster.dimensions'],
              'isDisabled': isdisabled
            })
          }
          this.clientboxtypelistall.push({
            'id': 'Other',
            'label': 'Other',
            'product': 'Other',
            'dimension': {L: "", B: "", H: ""},
            'isDisabled': false
          })
          this.clientboxtypelist.push(this.clientboxtypelistall);
          for (var i =0; i < tempProducts.length; i++) {
            this.clientproductlist.push({
              'id': tempProducts[i],
              'label': tempProducts[i]
            })
          }
          this.clientproductlist.push({
            'id': 'Other',
            'label': 'Other'
          })
          this.clientproductlistall = this.clientproductlist
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
      }
    },
    selectedBoxType(index) {
      if (this.selectedboxtype[index]) {
        this.form.boxdimension[index].length = this.selectedboxtype[index].dimension.L;
        this.form.boxdimension[index].breadth = this.selectedboxtype[index].dimension.B;
        this.form.boxdimension[index].height = this.selectedboxtype[index].dimension.H;
        this.form.boxtype[index] = this.selectedboxtype[index].label;
        this.setVolumetricWt(index)
        // this.otherbox[index] = (this.selectedboxtype[index].label == "Other") ? true : false;
      } else {
      }
      if (this.selectedboxtype[index].label == "Other") {
        this.editDimensionflag[index] = false;
      } else {
        this.editDimensionflag[index] = true;
      }
    },
    selectedProduct(index) {
      if (this.selectedproduct[index]) {
        this.isProductSelected[index] = true;
        if(this.selectedproduct[index].id == "Other") {
          this.otherproduct[index] = true;
          this.clientboxtypelist[index] = this.clientboxtypelistall
          this.editDimensionflag[index] = false;
          this.form.skulist[index] = this.selectedproduct[index].id;
        } else {
          this.clientboxtypelist[index] = this.clientboxtypelistall.filter(item => {return item.product ==  this.selectedproduct[index].id})
          this.otherproduct[index] = false;
          this.editDimensionflag[index] = false;
          this.form.skulist[index] = this.selectedproduct[index].id;
        }
        this.form.boxdimension[index].length = '';
        this.form.boxdimension[index].breadth = '';
        this.form.boxdimension[index].height = '';
        this.form.boxtype[index] = null;
        this.form.averagevolumetricweight[index] = "";
        this.selectedboxtype[index] = undefined;
      } else {
      }
    },
    setBoxProduct(item, index) {
      if (item.boxtype == "Other") {
        this.selectedboxtype[index] = this.clientboxtypelistall.filter(el => {return el.label ==  item.boxtype})[0]
        // this.otherbox[index] = true;
      } else {
        this.selectedboxtype[index] = this.clientboxtypelistall.filter(el => {return el.label ==  item.boxtype})[0]
        // this.otherbox[index] = false;
      }
      if (item.skulist == "Other") {
        this.selectedproduct[index] = this.clientproductlistall.filter(el => {return el.id ==  item.skulist})[0]
        // this.otherproduct[index] = true;
      } else {
        this.selectedproduct[index] = this.clientproductlistall.filter(el => {return el.id ==  item.skulist})[0]
        // this.otherproduct[index] = false;
      }
    },
    async getAirCargoData() {
      try {
        let InputPayload = {};
        let result = await BookingService.getAirCargoData(InputPayload);
        if (result.data.code == 200) {
          this.airCargoOptions = result.data.data;
          if (this.airCargoOptions.resultbusinesstype.length == 1) {
            this.businesstype = this.airCargoOptions.resultbusinesstype[0];
            this.businesstypedisabled = true;
          }
        }else{
          this.$alertify.error(result.data.message);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getAirCargoRates(totalvolumetricweight) {
      try {

        let InputPayload = {
          awb : this.awbnumber,
          clientid : this.clientid,
          clientbusinessaccountid :this.clientbusinessaccid,
          businesstype :this.businesstype.id,
          airline :this.airlinename.id,
          producttype :this.producttype.id,
          flighttype :this.flighttype.id,
          origincity : this.City,
          destinationcity : this.ConsigneeCity,
          physicalweight : this.TotalShipmentWeight,
          volumetricweight :totalvolumetricweight,
          mpsquantity :this.NumberOfMPS
        };
        let result = await BookingService.getAirCargoBill(InputPayload);
        if (result.data.code == 200) {
          this.airCargobillData = result.data.data
          return true;
        }else{
          this.$alertify.error(result.data.message);
          return false;
        }

      } catch (err) {
        console.log(err);
      }
    },
    async getWalletBalance(){
      try {

        let InputPayload = {
          customerId :this.bookingData.cbid,
        };

        let result = await BookingService.getWalletBalance(InputPayload);
        if (result.data.code == 200) {
          return {valid : 1 ,message: result.data.message , data : result.data.data}
        }else{
          return {valid : 0 ,message: result.data.message,data :null}
        }

      } catch (err) {
        console.log(err);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/Information/basicinformation/basicinformation.component.js